export default function ImpactStats() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-foreground-400 mb-4">
            Our Reach
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
            Independent journalism
            <br />
            <span className="italic font-normal text-primary-600">amplified</span> by community
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-xl leading-relaxed">
            We bring together voices from across the globe to deliver stories that matter — without paywalls, without bias, and without compromise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div className="relative bg-accent-100/80 rounded-lg p-6 md:p-8 overflow-hidden group cursor-pointer">
            <div className="relative z-10">
              <span className="font-heading text-5xl md:text-7xl font-bold text-accent-700">2.4M</span>
              <p className="mt-2 md:mt-3 text-sm md:text-base text-foreground-800 font-medium max-w-xs">
                Monthly readers across 140 countries, consuming over 8 million page views each month.
              </p>
              <p className="mt-3 md:mt-4 text-xs italic text-accent-600 font-heading">
                &ldquo;The most trusted independent voice in digital journalism&rdquo;
              </p>
            </div>
            <div className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50 flex items-center justify-center cursor-pointer group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-up-line text-lg text-accent-600"></i>
            </div>
          </div>

          <div className="relative bg-secondary-100/80 rounded-lg p-6 md:p-8 overflow-hidden group cursor-pointer">
            <div className="relative z-10">
              <span className="font-heading text-5xl md:text-7xl font-bold text-secondary-700">500+</span>
              <p className="mt-2 md:mt-3 text-sm md:text-base text-foreground-800 font-medium max-w-xs">
                Original long-form features published annually, with an average read time of 12 minutes per piece.
              </p>
              <p className="mt-3 md:mt-4 text-xs italic text-secondary-600 font-heading">
                &ldquo;Where depth meets accessibility&rdquo;
              </p>
            </div>
            <div className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50 flex items-center justify-center cursor-pointer group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-up-line text-lg text-secondary-600"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}